
const STORAGE_KEYS = {
  STORE_CLICKED: 'app_store_clicked',
  POPUP_CLOSES: 'popup_close_count',
  SESSION_SHOWN: 'popup_shown_this_session'
};

class AppPopup extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.initialized = false;
    // this.targetPage = this.getAttribute('target-page') || '/';
  }

  connectedCallback() {
    if (!this.initialized && this.shouldShowPopup()) {
      this.render();
      this.attachEventListeners();
      this.markPopupShownThisSession();
      this.initialized = true;
    }
  }

  shouldShowPopup() {
    if (["ios", "android"].includes(Capacitor.getPlatform())) return false;
    // if (!window.location.pathname.includes(this.targetPage)) return false;
    if (sessionStorage.getItem(STORAGE_KEYS.SESSION_SHOWN)) return false;
    if (localStorage.getItem(STORAGE_KEYS.STORE_CLICKED)) return false;
    const closeCount = parseInt(localStorage.getItem(STORAGE_KEYS.POPUP_CLOSES) || '0');
    return closeCount < 3;
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        /* Overlay styles */
        .app-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(3px);
          z-index: 1000000000001;
          animation: fadeIn 0.3s ease-out;
        }
        /* Popup container */
        .app-popup {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: #0A0A0A;
          color: white;
          padding: 2rem;
          border-radius: 1rem;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          z-index: 1000000000002;
          max-width: 90%;
          width: 400px;
          animation: slideIn 0.3s ease-out;
        }
        .app-popup-content {
          text-align: center;
        }
        .app-popup h2 {
          color: white;
          margin: 0 0 1rem;
          font-size: 2rem;
          font-weight: 600;
        }
        .app-popup p {
          color: #f1f1f1;
          margin-bottom: 1.5rem;
        }
        .app-popup-close {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
          width: 3rem;
          height: 3rem;
          border: none;
          background: none;
          font-size: 2.5rem;
          cursor: pointer;
          color: #6b7280;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        .app-popup-close:hover {
          background-color: #f3f4f6;
        }
        .app-popup-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translate(-50%, -40%);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%);
          }
        }
      </style>
      <div class="app-popup-overlay"></div>
      <div class="app-popup">
        <div class="app-popup-content">
          <button class="app-popup-close" aria-label="Zavřít vyskakovací okno">×</button>
          <h2>Stáhněte si naši mobilní aplikaci!</h2>
          <p>Nakupujte na cestách s naší mobilní aplikací!</p>
          <div class="app-popup-buttons">
            <a href="https://apps.apple.com/us/app/fansbrands/id6657949979" target="_blank" rel="noopener" class="app-store-button">
              <img src="//fansbrands.cz/cdn/shop/t/14/assets/app-store-button.avif?v=74184245195987108661791201897" alt="Stáhnout z App Store" style="height: 48px;">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.fansbrands.app" target="_blank" rel="noopener" class="play-store-button">
              <img src="//fansbrands.cz/cdn/shop/t/14/assets/play-store-button.avif?v=127107062902960603131791201897" alt="Stáhnout z Google Play" style="height: 48px;">
            </a>
          </div>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    const closeButton = this.shadowRoot.querySelector('.app-popup-close');
    const overlay = this.shadowRoot.querySelector('.app-popup-overlay');
    const storeButtons = this.shadowRoot.querySelectorAll('.app-store-button, .play-store-button');

    closeButton.addEventListener('click', () => this.closePopup());
    overlay.addEventListener('click', () => this.closePopup());
    storeButtons.forEach(button =>
      button.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEYS.STORE_CLICKED, 'true');
        this.closePopup();
      })
    );
  }

  closePopup() {
    const currentCloses = parseInt(localStorage.getItem(STORAGE_KEYS.POPUP_CLOSES) || '0');
    localStorage.setItem(STORAGE_KEYS.POPUP_CLOSES, (currentCloses + 1).toString());
    this.remove();
  }

  markPopupShownThisSession() {
    sessionStorage.setItem(STORAGE_KEYS.SESSION_SHOWN, 'true');
  }
}

customElements.define('app-popup', AppPopup);
